import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  ViewChild,
  SimpleChanges,
} from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
    selector: 'mat-select-extend',
    templateUrl: './mat-select-extend.component.html',
    styleUrls: ['./mat-select-extend.component.scss'],
    standalone: false
})
export class MatSelectExtendComponent implements OnInit {
  public selectCtrl: FormControl;
  public filterCtrl: FormControl = new FormControl('');

  /** Label of the search placeholder */
  @Input() placeholderFilter = 'Select One';
  @Input() placeholderSelect = 'Selection';
  @Input() isMultiple = 'true';
  @Input() longDescription;

  private _dataSource: Array<any> = [];
  @Input()
  set dataSource(value: Array<any>) {
    this._dataSource = value;

    if (this.isMultiple) this._setDataSourceMultiple();
  }
  get dataSource() {
    return this._dataSource;
  }

  private _valueSelect: any;
  @Input() set valueSelect(value: any) {
    this._valueSelect = value;

    if (this._valueSelect == null) {
      this._resetSelectedCtrl();
    } else this.selectCtrl = new FormControl(this.valueSelect);
  }
  get valueSelect() {
    return this._valueSelect;
  }

  @Output() valueSelectChange: EventEmitter<any> = new EventEmitter<any>();

  @ViewChild('searchinput') searchinput;

  public ngOnInit(): void {
    if (this.isMultiple) this.dataSource.forEach((x) => (x.selected = false));
  }

  public onClick(e: any) {
    let response = JSON.parse(JSON.stringify(this.selectCtrl.value));

    if (this.isMultiple) {
      // this.dataSource.forEach(x => (x.id != 0 && x.id == e.id) ? x.selected = !x.selected : (x.description == e.description) ? x.selected = !x.selected : '');
      this.dataSource.forEach((x) =>
        x.id == e.id ? (x.selected = !x.selected) : ''
      );
      this.selectCtrl = new FormControl(
        this.dataSource.filter((x) => x.selected == true)
      );
      response = JSON.parse(JSON.stringify(this.selectCtrl.value));
      response.forEach((x) => delete x.selected);
    }

    this.valueSelectChange.emit(response);
  }

  public inputFocus() {
    this.filterCtrl.setValue('');
    this.searchinput.nativeElement.focus();
  }

  public compareSelected(option: any, value: any): boolean {
    if (JSON.stringify(value) == '{}') return false;

    //En esta funcion el scope es el del mat select es por esto que no se puede acceder a fn del controller.
    let optionKey = option.id?.toString().toUpperCase();
    let valueKey = value.id?.toString().toUpperCase();

    return optionKey === valueKey;
  }

  public deselect(event: any) {
    event.preventDefault();
    event.stopPropagation();
    this._resetSelectedCtrl();
    this.valueSelectChange.emit(this.selectCtrl.value);
  }

  private _setDataSourceMultiple() {
    let values: Array<string> = [];

    if (this.valueSelect != null) values = this.valueSelect.map((x) => x.id);

    this._dataSource.forEach((x) => (x.selected = values.includes(x.id)));
  }

  private _resetSelectedCtrl() {
    this.selectCtrl = this.isMultiple
      ? new FormControl([])
      : new FormControl({});
    this.dataSource.forEach((x) => (x.selected = false));
  }
}
